import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from '../_services/loader.service';
@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {
  constructor(private loaderService: LoaderService) { }

  calls = 0;
  responses = 0;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!req.url.includes('ListarProveedorCotizaciones')
       && !req.url.includes('Buscar')
       && !req.url.includes('TieneCartera')
       && !req.url.includes('OrgVRazonesSociales')
       && !req.url.includes('UtilizaImpuestoLineas')
       && !req.url.includes('ImprimirPDF')
       && !req.url.includes('ObtenerVendedores')
       && !req.url.includes('ListarOrgc')
       ){
      this.showLoader();
    }



    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if(!req.url.includes('ListarProveedorCotizaciones')
           && !req.url.includes('Buscar')
           && !req.url.includes('TieneCartera')
           && !req.url.includes('OrgVRazonesSociales')
           && !req.url.includes('UtilizaImpuestoLineas')
           && !req.url.includes('ImprimirPDF')
           && !req.url.includes('ObtenerVendedores')
           && !req.url.includes('ListarOrgc')
          ){
          this.onEnd();
        }

      }
    },
      (err: any) => {
        this.onEnd();
      }));
  }
  private onEnd(): void {
      this.hideLoader();

    this.hideGridLoader();
  }
  private showLoader(): void {
    this.loaderService.show();
  }
  private hideLoader(): void {
    this.loaderService.hide();
  }

  private showGridLoader(): void {
    this.loaderService.showGrid();
  }
  private hideGridLoader(): void {
    this.loaderService.hideGrid();
  }
}
